import posthog, { Properties } from 'posthog-js'
import { TrackEvent } from '../types/TrackEvents'
import { UserPermissionsType } from '@repo/types/common'

export default function capture(
  event: TrackEvent | string,
  properties?: Properties | null
) {
  // Explicit check instead of optional chaining to prevent tree-shaking
  if (posthog && typeof posthog.capture === 'function') {
    posthog.capture(event, {
      ...properties,
    })
  }
}

export function logout() {
  posthog?.reset()
}

export function identify({
  email,
  currentExamId,
  examName,
  academyName,
  academyId,
  fullName,
  joinDate,
}: {
  email: string
  currentExamId?: number
  examName?: string
  academyName?: string
  fullName?: string
  academyId?: number
  joinDate?: string
}) {
  if (email) {
    posthog?.identify(email, {
      email,
      currentExamId,
      examName,
      academyName,
      academyId,
      fullName,
      joinDate,
    })
  }
}

/**
 * Persists properties as both person properties ($set) and super properties (register).
 * - $set: stored on the person in PostHog, queryable server-side
 * - register: included in all subsequent events from this client
 */
export function setPersonProperties(
  properties: Record<string, string | boolean>
) {
  posthog?.setPersonProperties?.(properties)
  posthog?.register?.(properties)
}

export function reloadFlags() {
  posthog?.reloadFeatureFlags?.()
}

export function getFeatureFlag(key: string): string | boolean | undefined {
  return posthog?.getFeatureFlag?.(key)
}

export function updateProperties({
  email,
  currentExamId,
  examName,
  academyName,
  academyId,
  fullName,
  permissions,
  joinDate,
}: {
  email?: string
  currentExamId?: number
  examName?: string
  academyName?: string
  fullName?: string
  academyId?: number
  permissions?: UserPermissionsType[]
  joinDate?: string
}) {
  posthog?.register({
    email,
    currentExamId,
    examName,
    academyName,
    academyId,
    fullName,
    joinDate,
  })
}
